import EntityTable from "@mirage/components/entityTable/EntityTable";
import LinkCell from "@mirage/components/entityTable/components/LinkCell";
import { Box } from "@mui/system";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import PlanningApplicationsService from "@publicPortal/services/PlanningApplicationsService";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { Filter } from "@shared/mirage/entityTable/Filter";
import React, { memo, useCallback, useMemo } from "react";

export interface SearchResultTableProps {
    filter: Filter;
    title?: string;
    customPageRequest?: (pageRequest: IEntityPageRequest) => Promise<IEntityPageResult<unknown>>;
}

const planningAppService = new PlanningApplicationsService();
const pp = new PublicPortalRoutingService();

const PlanningApplicationsTable: React.FC<SearchResultTableProps> = memo(({ filter, title }) => {
    const columns = useMemo(() => {
        return [
            {
                field: "name",
                headerName: "Application Reference",
                renderCell: (params: GridRenderCellParams) => <LinkCell value={params.value} route={pp.PlanningApplicationRecordRoute(Number(params.id))} />,
                width: 140,
            },
            { field: "initialAppRef", headerName: "Initial Reference", width: 140 },
            { field: "address", headerName: "Address", flex: 0.75 },
            { field: "proposal", headerName: "Proposal", flex: 1 },
            { field: "receivedDate", headerName: "Received Date", width: 120, type: "date" },
            { field: "status", headerName: "Status", width: 180 },
            { field: "decision", headerName: "Decision", width: 180 },
        ];
    }, []);
    const onPageRequest = useCallback(async (pageRequest: IEntityPageRequest) => {
        const response = await planningAppService.pageRequest(pageRequest);
        return response;
    }, []);

    return (
        <Box sx={{ marginTop: "32px", height: "auto" }}>
            <EntityTable
                title={title}
                key="planning-applications-entityTable"
                stateKey="PlanningApplications"
                onPageRequest={onPageRequest}
                columns={columns}
                filter={filter}
                getRowHeight={() => "auto"}
            />
        </Box>
    );
});

export default PlanningApplicationsTable;
